import styles from './Loader.module.scss'

export function Loader() {
  return (
    <div className={styles.ring}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  )
}
